import type { SalesOrderListItem } from '@/lib/services/sales-orders/sales-orders.types'
import type { IndexDataTableRowPresentation } from '@/components/tables/IndexTable'
import { SalesOrderFulfillmentStatus } from '@/lib/enums/SalesOrderFulfillmentStatus'
import { SalesOrderRefundStatus } from '@/lib/enums/SalesOrderRefundStatus'
import { isCancelledSalesOrder } from './sales-order-presentation'

export function isSalesOrderUnread(order: Pick<SalesOrderListItem, 'read_at'>): boolean {
  return !order.read_at
}

export function getSalesOrderRowPresentation(
  order: Pick<
    SalesOrderListItem,
    'read_at' | 'cancelled_at' | 'fulfillment_status' | 'refund_status'
  >
): IndexDataTableRowPresentation {
  const isUnread = isSalesOrderUnread(order)
  const isCancelled = isCancelledSalesOrder(order)
  const isFulfilled = order.fulfillment_status === SalesOrderFulfillmentStatus.Fulfilled.Value
  const isRefunded = order.refund_status === SalesOrderRefundStatus.Refunded.Value
  const lifecycleTone = isCancelled || isRefunded ? 'destructive' : isFulfilled ? 'success' : null

  return {
    tone: lifecycleTone ?? 'neutral',
    attention: isUnread ? 'unread' : undefined,
    contentTone: lifecycleTone ? 'muted' : undefined,
  }
}
